import { ErrorHandler, Injectable, inject } from '@angular/core';
import { PosthogService } from './posthog.service';

@Injectable()
export class LoggingErrorHandler implements ErrorHandler {
  private readonly posthogService = inject(PosthogService);

  handleError(error: unknown): void {
    this.posthogService.captureException(error, {
      source: 'angular.errorHandler',
    });
  }
}
